import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_36: FaireProductEntity = {
  token: "catalog_prod_prod-36",
  type: "product",
  name: "Gift Box",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 41.85,
  msrpDollars: 104.63,
  sku: "PA0036",
  caseSize: 2,
  material: "Linen",
  collectionToken: "col_pattern-play",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 229,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_stationery-writing"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
